function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41 44"
}, props), React.createElement("path", {
  d: "M40.149 41.935c-.015.546-.03 1.092-.118 1.662-.13.036-.184.047-.286.055-.708.007-1.368.016-2.071.01-.192-.006-.341.004-.53 0-.117-.001-.197.01-.323.006-.755-.007-1.463.001-2.217-.006-1.516-.005-2.986.005-4.504.002-6.671-.017-13.295-.019-19.918-.018-.104 0-.207.022-.358.017-1.066-.007-2.084.001-3.15-.004-.614-.004-1.18.007-1.792.004-.57-.004-1.092.005-1.66-.002-.267-.006-.488.005-.755.002-.293-.003-.54.007-.83 0-.19-.008-.339 0-.487.009L0 43.61v-1.554c.098-.24.178-.459.298-.49.231-.062.486-.038.729-.014.32.032.412-.12.346-.498.005-.352 0-.654.004-1.009.003-.753-.004-1.454-.001-2.21.003-1.288-.004-2.521 0-3.808.012-2.474.013-4.892.017-7.31.001-.862.175-1.064.917-1.065 2.608-.002 5.216-.002 7.824 0 .744 0 .906.193.906 1.064v14.798h.722v-.73-25.04c0-1.147.345-1.546 1.348-1.546 4.621-.002 9.242-.002 13.863-.001 1.075 0 1.396.37 1.396 1.606V41.51h.721v-.686c0-4.719 0-9.437.002-14.155 0-.81.185-1.016.902-1.017 2.608-.002 5.216-.001 7.824 0 .738 0 .925.217.928 1.056.007 2.022.014 4.043.01 6.12-.003 1.604.003 3.154 0 4.76-.002.93.006 1.806.004 2.735-.016 1.439-.125 1.241 1.006 1.255.12.001.24.008.362.056l.02.301zm-15.656-13.13c.169-.01.337-.022.531-.035v-3.658H21.8v3.694h2.694zm-7.429-3.74H15.12v3.7h3.253v-2.34c0-1.36 0-1.36-1.308-1.36zm7.992-2.758v-3.31H21.8v3.673c1.016 0 1.994.007 2.97-.011.096-.002.189-.157.286-.351zm.004 10.999v-2.05h-3.259v3.626h3.26v-1.576zm-9.862-10.66h3.127V18.99h-3.203c0 1.215 0 2.398.076 3.658zM18.37 33.19v-1.944h-3.246v3.637h3.246v-1.693zM7.748 31.973l-.538.034v.99c0 1.353.17 1.517 1.35 1.268.184-.039.36-.125.524-.185v-2.106H7.748zm27.148-1.583c.055.065.108.184.164.186.566.014 1.133.008 1.722.008v-2.122h-1.889c0 .64 0 1.23.003 1.928zm-2.616.212h.621v-2.137h-1.85v2.137h1.23zM9.095 28.508l-1.85-.12v2.166H9.12c0-.676 0-1.309-.025-2.046zm-5.749.027v2.015h1.855v-2.1c-.626 0-1.214 0-1.855.085zm31.547 4.875v.712h1.878v-2.105h-1.878v1.393zM3.345 32.106v2.005h1.856v-2.094c-.627 0-1.217 0-1.856.09zm31.549 3.748v1.803h1.873v-2.124c-.546 0-1.052-.012-1.558.01-.107.004-.21.13-.316.31zm-2.617 1.851h.616v-2.13h-1.845v2.13h1.229zm-25.065-.722v.677h1.87v-2.08h-1.87v1.403zm-3.88-.919v1.608h1.875v-2.14c-.549 0-1.069-.022-1.585.02-.105.008-.194.26-.29.512zM31.11 32l-.141 2.119h1.93v-2.143c-.585 0-1.14 0-1.789.024z",
  fill: "url(#paint0_linear_4662_7841)"
}), React.createElement("path", {
  d: "M17.926 5.246c-.578-.689-1.127-1.347-1.688-2.02.642-.106 1.31-.24 1.984-.323.432-.053.723-.206.9-.711.25-.713.59-1.387.94-2.192.339.767.669 1.444.937 2.15.186.491.446.722.928.763.671.056 1.336.208 2.021.322-.573.666-1.123 1.272-1.633 1.92-.133.17-.214.48-.19.708.092.84.237 1.674.38 2.63-.748-.44-1.427-.817-2.086-1.235-.261-.165-.454-.163-.715.005-.65.42-1.324.794-2.075 1.237.137-.91.271-1.732.377-2.558.028-.214-.032-.443-.08-.696z",
  fill: "url(#paint1_linear_4662_7841)"
}), React.createElement("path", {
  d: "M27.839 7.723c-.022.376-.037.72-.006 1.058.036.409.111.813.183 1.31-.5-.295-.94-.527-1.355-.81-.27-.183-.49-.201-.766-.012-.416.283-.858.516-1.374.82.096-.657.208-1.215.246-1.779a1.167 1.167 0 00-.208-.711c-.325-.426-.707-.797-1.141-1.272.61-.107 1.11-.16 1.595-.295.2-.056.42-.242.528-.44.26-.481.46-1.004.727-1.604.271.615.483 1.15.742 1.653.089.173.282.339.453.382.506.126 1.024.19 1.607.29-.432.494-.818.934-1.231 1.41z",
  fill: "url(#paint2_linear_4662_7841)"
}), React.createElement("path", {
  d: "M13.622 4.535c.08-.175.143-.31.249-.534.257.579.497 1.071.695 1.585.12.31.287.443.584.475.481.051.958.158 1.585.267-.422.452-.741.831-1.096 1.163-.297.277-.358.577-.268.987.1.455.143.926.24 1.58-.527-.298-.948-.5-1.334-.766-.29-.2-.519-.213-.812-.006-.397.28-.827.5-1.347.806.095-.627.161-1.16.259-1.686.068-.364.007-.629-.252-.888-.35-.351-.654-.763-1.031-1.213.426-.069.827-.165 1.232-.191.486-.032.813-.235.957-.793.067-.262.212-.498.339-.786z",
  fill: "url(#paint3_linear_4662_7841)"
}), React.createElement("path", {
  d: "M10.216 8.729c.266.047.49.088.863.158-.888.661-1.278 1.455-.8 2.623-.835-.71-1.616-.82-2.468.137.077-.682.266-1.206.147-1.617-.122-.422-.544-.734-.876-1.145.46-.099.96-.058 1.27-.314.316-.26.444-.812.662-1.25.45.422.313 1.438 1.202 1.408z",
  fill: "url(#paint4_linear_4662_7841)"
}), React.createElement("path", {
  d: "M30.172 8.694c.229-.243.432-.463.595-.718.127-.199.205-.44.376-.823.258 1.245.851 1.83 1.96 1.697-.883.688-1.19 1.514-.765 2.668-.836-.73-1.623-.838-2.45.028.348-1.138.181-1.997-.693-2.678l.977-.174z",
  fill: "url(#paint5_linear_4662_7841)"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_4662_7841",
  x1: "20.074",
  y1: "14.197",
  x2: "20.074",
  y2: "43.672",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4296B3"
}), React.createElement("stop", {
  offset: ".986",
  stopColor: "#1C80A3"
})), React.createElement("linearGradient", {
  id: "paint1_linear_4662_7841",
  x1: "20.093",
  y1: "0",
  x2: "20.093",
  y2: "8.5",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4296B3"
}), React.createElement("stop", {
  offset: ".986",
  stopColor: "#1C80A3"
})), React.createElement("linearGradient", {
  id: "paint2_linear_4662_7841",
  x1: "26.244",
  y1: "3.988",
  x2: "26.244",
  y2: "10.091",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4296B3"
}), React.createElement("stop", {
  offset: ".986",
  stopColor: "#1C80A3"
})), React.createElement("linearGradient", {
  id: "paint3_linear_4662_7841",
  x1: "13.914",
  y1: "4.001",
  x2: "13.914",
  y2: "10.092",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4296B3"
}), React.createElement("stop", {
  offset: ".986",
  stopColor: "#1C80A3"
})), React.createElement("linearGradient", {
  id: "paint4_linear_4662_7841",
  x1: "9.08",
  y1: "7.32",
  x2: "9.08",
  y2: "11.647",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4296B3"
}), React.createElement("stop", {
  offset: ".986",
  stopColor: "#1C80A3"
})), React.createElement("linearGradient", {
  id: "paint5_linear_4662_7841",
  x1: "31.149",
  y1: "7.153",
  x2: "31.149",
  y2: "11.546",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4296B3"
}), React.createElement("stop", {
  offset: ".986",
  stopColor: "#1C80A3"
})))));